import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=aba3a332&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=aba3a332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba3a332",
  null
  
)

export default component.exports